import React, { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';
import { MainMapMapControlButtonList } from '../../component/MainMapMapControlButtonList';
import { IconPlus } from '@bvt-assets/icon/icon-plus';
import { IconMinus } from '@bvt-assets/icon/icon-minus';
import { IconFocus } from '@bvt-assets/icon/icon-focus';
import { IconBaseMap } from '@bvt-assets/icon/icon-baseMap';
import { IconFilterOne } from '@bvt-assets/icon/icon-filterOne';
import { IconFullScreen } from '@bvt-assets/icon/icon-fullScreen';
import { IconOpenLayer } from '@bvt-assets/icon/icon-openLayer';
import { useMainMap } from '../../hook/useMainMap';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '@bvt-features/auth/hooks';
import { IconGrianaFill } from '@bvt-assets/icon/icon-griana-fill';
import { useModuleBar } from '@bvt-features/mainmap/module-bar/hook';
import { featureFlags } from '@bvt-utils';

const ZoomLevel = () => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());

  const onZoomEnd = () => {
    setZoom(map.getZoom());
  };

  useEffect(() => {
    if (map) {
      map.on('zoomend', onZoomEnd);
    }
    return () => {
      map.off('zoomend', onZoomEnd);
    };
  }, []);

  return (
    <div style={{ fontSize: '1rem', width: '1rem', height: '1rem' }}>
      {zoom}
    </div>
  );
};

/**
 * @author Randa <m.randa@bvarta.com>
 * @description Layout Sidebar for tooling
 * @type {import('react').FC}
 */
export const MainMapToolbarContainer = () => {
  const mapp = useMainMap();
  const map = useMap();
  const AUTH = useAuth();
  const dispatch = useDispatch();
  const fullscreen = useSelector(
    (state) => state.interactive.MAP.FULL_SCREEN.value
  );
  const modulebar = useModuleBar();
  const selectedModule = modulebar.state.submenu_selected?.code;

  const internalDisableHandleMapEvent = (param) => {
    if (param) {
      map.scrollWheelZoom.disable();
      map.doubleClickZoom.disable();
    } else {
      map.scrollWheelZoom.enable();
      map.doubleClickZoom.enable();
    }
  };

  const handleOpenFullscreen = () => {
    document.documentElement.requestFullscreen();
    dispatch({ type: 'SET_FULLSCREEN', payload: !fullscreen });
  };

  return (
    <div
      className='bvt-map__toolbar'
      onMouseEnter={() => internalDisableHandleMapEvent(true)}
      onMouseLeave={() => internalDisableHandleMapEvent(false)}
      style={{
        top: (window.innerHeight * 0.22) / 16 + 'rem',
        position: 'fixed',
        zIndex: 4024,
        right: `${
          mapp.state.activeMenu ? mapp.state.activeMenuWidth + 'px' : '0.5rem'
        }`,
        padding: '0.5rem',
        transition: '0.25s ease-in-out',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <MainMapMapControlButtonList
        data={[
          [
            {
              children: <IconPlus />,
              onClick: () => map.zoomIn(1),
              title: 'Zoom In',
            },
            {
              children: <ZoomLevel />,
            },
            {
              children: <IconMinus />,
              onClick: () => map.zoomOut(1),
              title: 'Zoom Out',
            },
            {
              children: <IconFocus />,
              disabled: true,
            },
          ],
          [
            {
              children: <IconBaseMap />,
              onClick: () => mapp.setActiveMenu('BASEMAP'),
              title: 'Base Map',
            },
            {
              children: <IconFilterOne />,
              onClick: () => mapp.setActiveMenu('LAYERING_VISIBLITY'),
              title: 'Layer Visiblity',
            },
            {
              children: <IconFullScreen />,
              onClick: () => handleOpenFullscreen(),
              title: 'Fullscreen',
            },
          ],
          (AUTH.hasAccess('DATEX') && [
            {
              children: <IconOpenLayer />,
              disabled: false,
              onClick: () => mapp.setActiveMenu('DATEX'),
              title: 'Data Explorer',
            },
          ]) ||
            [],
          (featureFlags.pertamina.isPhase2Enabled &&
            AUTH.hasAccess('MAPANA.ASMANPERTAMINA') &&
            selectedModule === 'asset-management-pertamina' && [
            {
              children: <IconGrianaFill />,
              disabled: false,
              onClick: () => mapp.setActiveMenu('GRIANA_PERTAMINA'),
              title: 'Grid Analysis',
            },
          ]) ||
            [],
        ]}
      />
    </div>
  );
};
